import PropTypes from 'prop-types';
import StoryCircle from './StoryCircle';

function StoriesBar({ stories }) {
  if (!stories || stories.length === 0) {
    return null;
  }

  return (
    <div className="bg-puzzle-surface border border-puzzle-border rounded-lg mb-4 p-4">
      <div className="flex gap-4 overflow-x-auto hide-scrollbar">
        {stories.map((story) => (
          <StoryCircle
            key={story.id}
            puzzleId={story.puzzleId}
            username={story.username}
            avatarUrl={story.avatarUrl}
            hasNewStory={story.hasNewStory}
          />
        ))}
      </div>
    </div>
  );
}

StoriesBar.propTypes = {
  stories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      puzzleId: PropTypes.string.isRequired,
      username: PropTypes.string.isRequired,
      avatarUrl: PropTypes.string,
      hasNewStory: PropTypes.bool,
    }),
  ),
};

StoriesBar.defaultProps = {
  stories: [],
};

export default StoriesBar;
